import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {TableColumn, TableSettings} from "../../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../../common/AbstractListView";
import periodCloseIcon from '../../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../../img/periodclose-12.svg';
import constants from '../../../../constants';
import {Search} from "../../../../filtering";
import {NavigationType, openNewPage} from '../../../../util/navigationHelpers';
import * as XCol from '../../../../framework.core/XExportColumn';
import {
  DateRenderer,DateTimeRenderer,FloatRenderer,TextAlignLeftRenderer,TextRenderer
} from '../../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../../uiControls/UniqueLinkButton';
import PrimaryButton from '../../../../ui/PrimaryButton';
import ApplicationContext from '../../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../../common/JobListViewContext';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../../ui/ActionButton';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import {getTbNameByJobName, JobNames} from "../../../../framework.core/JobNames";
import {accountingJournalList} from "../../tableSettings";
import ListViewShortcutMenu from '../../../common/ListViewShortcutMenu';
import IfmsModal from "../../../../ui/IfmsModal";
import SearchJournal from "./more/SearchJournal";
import JournalVoucher from "./more/JournalVoucher";
import GeneralLedgerDetails from '../../reports/GeneralLedger';
import { DocumentType } from '../../../../framework.core/DocumentType';
import ToolboxMenuItem from '../../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../../ui/menu/Menu';
import { JournalLedgerListItem } from '../../../../fms.data/models/JournalLedgerListItem';
import { SuntekSettings, SystemSettings } from '../../../../ifmsTypes';
import { FmsSecTask, ListFilterType } from '../../../../fms.core/constants';
import { findSecurityTask, findSecurityTaskWithBranch } from '../../../../util';
import { StatusNotUseFileLockedRenderer } from '../../../common/commonListRenderers';
import useExternalScreenFilter from '../../../../hooks/useExternalScreenFilter';
import _ from 'lodash';
import { Decimalformat } from '../../../common/commonExportFormat';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconButton, { EditIconButton, EditIconButton2, ViewIconButton, ViewIconButton2 } from '../../../../ui/IconButton';
import SearchIcon from '../../../../img/SearchJournal.svg';
import SearchIcon2 from '../../../../img/SearchJournal2.svg';
import SearchIcon_D from '../../../../img/SearchJournal_Dark.svg';
import SearchIcon2_D from '../../../../img/SearchJournal_Dark2.svg';
import BookIcon from '../../../../img/JournalBook.svg';
import BookIcon2 from '../../../../img/JournalBook2.svg';
import BookIcon_D from '../../../../img/JournalBook_Dark.svg';
import BookIcon2_D from '../../../../img/JournalBook_Dark2.svg';
import VoucherIcon from '../../../../img/JournalVoucher.svg';
import VoucherIcon2 from '../../../../img/JournalVoucher2.svg';
import VoucherIcon_D from '../../../../img/JournalVoucher_Dark.svg';
import VoucherIcon2_D from '../../../../img/JournalVoucher_Dark2.svg';
import DebitIcon from '../../../../img/DebitEntry.svg';
import DebitIcon2 from '../../../../img/DebitEntry2.svg';
import DebitIcon_D from '../../../../img/DebitEntry_Dark.svg';
import DebitIcon2_D from '../../../../img/DebitEntry_Dark2.svg';
import CreditIcon from '../../../../img/CreditEntry.svg';
import CreditIcon2 from '../../../../img/CreditEntry2.svg';
import CreditIcon_D from '../../../../img/CreditEntry_Dark.svg';
import CreditIcon2_D from '../../../../img/CreditEntry_Dark2.svg';
import BeginningIcon from '../../../../img/BeginningJournal.svg';
import BeginningIcon2 from '../../../../img/BeginningJournal2.svg';
import BeginningIcon_D from '../../../../img/BeginningJournal_Dark.svg';
import BeginningIcon2_D from '../../../../img/BeginningJournal_Dark2.svg';

function IndicatorRenderer({ data, row}:any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;

  return (
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  // const sourceUrl = `${history.location.pathname}${history.location.search}`;
  const operation = 'accounting';
  const appContext = useContext(ApplicationContext);

  const selectedElement = jobListContext.selectedElement as JournalLedgerListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();

  async function openSpecialJournalView(openMenu: string) {
    if (openMenu === 'CreditEntry' || openMenu === 'DebitEntry' || openMenu === 'BeginningJournal') {
      if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acJournal/add`)) {
        await showGlobalOkDialog(<p>New operation is already in progress</p>);
        return;
      }

      //let tbId = "0";
      let mode = "add"
      let fkey = "0";
      let seq = "0";
      let jourType = "";
      let tbType = "10";

      if (openMenu === 'DebitEntry') {
        jourType = "DR";
      }
      else if (openMenu === 'CreditEntry') {
        jourType = "CR";
      }
      else if (openMenu === 'BeginningJournal') {
        var apiResult = await appContext.api.getBeginningJournal();
        if (!apiResult || apiResult.length <= 0) {

        } else {
          jourType = "B";
          mode = _.isEmpty(apiResult.result[0]) ? "add" : "view"
          //tbId = _.isEmpty(apiResult[0]) ? "0" : apiResult[0]; // formPara
          fkey = _.isEmpty(apiResult.result[0]) ? "0" : `10T_SLIPHD${apiResult.result[0]}${apiResult.result[3]}`; // formPara2
          seq = _.isEmpty(apiResult.result[1]) ? "0" : apiResult.result[1]; // formPara3
          tbType = _.isEmpty(apiResult.result[2]) ? "10" : apiResult.result[2]; // formPara4
        }
      }

      openNewPage(history, `/${operation}/acJournal/${mode}/${fkey}/${seq}/${jourType}/${tbType}`, NavigationType.newPage);
      return;
    }
  }

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acJournal/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    openNewPage(history, `/${operation}/acJournal/add/0/0/T/10`, NavigationType.newPage);
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    // Edit Button도 View 모드로 동작후에 내부에서 Amend로 Edit Mode로 동작한다.
    // if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acJournal/edit`)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
    //   return;
    // }

    const fkey = selectedElement.fKey;
    const seq = selectedElement.seq;
    const type = selectedElement.type;
    const tbType = selectedElement.tbType;
    const editUrl = `/${operation}/acJournal/view/${fkey}/${seq}/${type}/${tbType}`;
    const viewUrl = `/${operation}/acJournal/view/${fkey}/${seq}/${type}/${tbType}`;

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }
    const fkey = selectedElement.fKey;
    const seq = selectedElement.seq;
    const type = selectedElement.type;
    const tbType = selectedElement.tbType;
    const sideMenu = selectedElement.sideMenu;

    const editUrl = `/${operation}/acJournal/view/${fkey}/${seq}/${type}/${tbType}`;
    const viewUrl = sideMenu === 'billings' ? `/${operation}/acJournal/view/${fkey}/${seq}/${type}/${tbType}/billings` : `/${operation}/acJournal/view/${fkey}/${seq}/${type}/${tbType}`;

    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctSlipJournalList, selectedElement.branch);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acJournal/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const fkey = selectedElement.fKey;
    const seq = selectedElement.seq;
    const type = selectedElement.type;
    const tbType = selectedElement.tbType;
    
    openNewPage(history, `/${operation}/acJournal/add/${fkey}/${seq}/${type}/${tbType}`, NavigationType.newPage);
  }

  return {create, edit, view, copy, openSpecialJournalView, operation};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, edit, view, copy } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as JournalLedgerListItem;

  const appContext = useContext(ApplicationContext);
  
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctSlipJournalList, selectedElement?.branch);

  const items = selectedElement?.sideMenu === 'billings' ?
    [{ label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit }] :
    [
      { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
      { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit },
      { label: 'Edit', shortcut: 'F3', separator: true, hidden: !listSec?.grantEdit },
      { label: 'Copy', shortcut: 'Ctrl+F2', separator: true, hidden: !listSec?.grantAdd, disabled: selectedElement.type !== "T" },
      { label: 'Search', shortcut: 'F5', separator: false },
    ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="journal-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    index,
    hidden: i?.hidden ?? false,
    disabled: i?.disabled ?? false
  }));

  

  function onMenuItemSelected(item: IfmsMenuItem) {
    if (selectedElement?.sideMenu==='billings') {
      switch (item.index) {
        case 0:
          view()
          break;
        default:
          break;
      }
    } else {
      switch (item.index) {
        case 0:
          create()
          break;
        case 1:
          view();
          break;
        case 2:
          edit();
          break;
        case 3:
          copy();
          break;
        case 4:
          jobListContext.triggerTableSearch('F5');
          break;
        case 5:
          jobListContext.reloadData();
          break;
        default:
          break;
      }
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem | null>(null);

  const selectedElement = jobListContext.selectedElement as JournalLedgerListItem;

  const { edit, view, copy, openSpecialJournalView, operation } = useSelectedOperations();

  const searchJournalSec = appContext.securityGrants?.find(x => x.securityTaskCode === FmsSecTask.AcctSearchJournal);
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctSlipJournalList, selectedElement?.branch);
  const hasSelectedRow = !!selectedElement;

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acJournal/add`);
  }

  //const hasSelectedRow = false;
  const canBeAdd = listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd && selectedElement.type === "T";
  
  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }
  
  useEffect(() => {
    const params = new URLSearchParams(history.location.search);
    const tooltip = params.get('tt') || '';


    const activeClass = appContext.useDarkMode ? 'e-job-btn-active-darkmode' : 'e-job-btn-active';
    const activeTabButton = document.getElementsByClassName(activeClass)[0] as HTMLInputElement;
    if (activeTabButton) {
      activeTabButton.dataset.tooltip = tooltip;
    }
},);
  if (selectedElement?.sideMenu === 'billings')
    return (
      <div className='ifms-common-no-vertical-separator-gap-margin'>
        {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}
          <ViewIconButton2 name='journal-list-view-button' disabled={!hasSelectedRow} onClick={view} useText />
          {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
            <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
              {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
            </IfmsModal>
          ) : null}
          <PrimaryButton name='journal-list-copy-button' disabled={!canBeCopied} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
      </div>
    );
  else
  return (
      <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <UniqueLinkButton newStyle name='journal-list-add-button' display="primary" link={`/${operation}/acJournal/add/0/0/T/10`} disabled={!canBeAdd} label={''} useOnlyIcon data-tooltip='New' iconMode={true} />
        <EditIconButton2 name='journal-list-edit-button' disabled={!canBeEdit} onClick={edit} useText/>
        <ViewIconButton2 name='journal-list-view-button' disabled={!hasSelectedRow} onClick={view} useText />
      </div>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
    <div className='ifms-common-vertical-gap-8'>
      {(searchJournalSec?.grantRead || appContext.user?.isSuntekAdmin) &&
        <>
          <IconButton data-tooltip='Search Journal' name='journal-list-search-button' icon={appContext.useDarkMode? SearchIcon2_D : SearchIcon2} useText
            onClick={() => setSelectedPopupMenuItem({
              label: 'Search Journal', separator: false,
              popupComponent:
                <SearchJournal
                  jobName={JobNames.SearchJournal}
                  selectedElementId={selectedElement?.id}
                  onPopupClose={onPopupClose}
                />,
            })}>
          </IconButton>
        </>
      } 
      <IconButton data-tooltip='Journal Book' name='journal-list-book-button' onClick={() => setSelectedPopupMenuItem({
        label: 'Journal Book', separator: false, popupComponent: <GeneralLedgerDetails documentType={DocumentType.GeneralLedger} />, // General Ledger와 동일한 UI를 사용한다.
      })} icon={appContext.useDarkMode? BookIcon2_D : BookIcon2} useText/>
      <IconButton data-tooltip='Journal Voucher' name='journal-list-voucher-button' onClick={() => setSelectedPopupMenuItem({
        label: 'Journal Voucher', separator: false, popupComponent: <JournalVoucher />,
      })} icon={appContext.useDarkMode? VoucherIcon2_D : VoucherIcon2} useText/>
    </div>

      {(appContext.suntekSettings?.company?.companyId === "FSSUNTEK" || appContext.suntekSettings?.company?.companyId === "IFMSSUNTEK" || appContext.user?.isSuntekAdmin) &&
        <div className='ifms-common-vertical-gap-8'>
          {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
          <>
            <IconButton data-tooltip='Debit Entry' icon={appContext.useDarkMode? DebitIcon2_D : DebitIcon2}
              name='journal-list-debitEntry-button'
              onClick={() => { openSpecialJournalView('DebitEntry'); }} useText>
            </IconButton>
          </>
          <>
            <IconButton data-tooltip='Credit Entry' icon={appContext.useDarkMode? CreditIcon2_D : CreditIcon2}
              name='journal-list-creditEntry-button'
              onClick={() => { openSpecialJournalView('CreditEntry'); }} useText>
            </IconButton>
          </>
          <>
            <IconButton data-tooltip='Beginning Journal' icon={appContext.useDarkMode? BeginningIcon2_D : BeginningIcon2}
              name='journal-list-beginningJournal-button'
              onClick={() => { openSpecialJournalView('BeginningJournal'); }} useText>
            </IconButton>
          </>
        </div>
      }
      <PrimaryButton name='journal-list-copy-button' disabled={!canBeCopied} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as JournalLedgerListItem;
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctSlipJournalList, selectedElement?.branch);
  const billingmenu = selectedElement?.sideMenu === 'billings';

  const {create, edit, view, copy} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {

    } else if (unprocessedFkey === "F2" && !billingmenu) {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3" && !billingmenu) {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "CTRL+F2" && !billingmenu) {
      if(listSec?.grantAdd && selectedElement.type === "T")
        copy();
    } 

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F9', 'F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  
  return (
    <></>
  );
}

//<pt220903: portal>
export function useJournal() {
  const history = useHistory();
  const {setFilterForScreenExternally} = useExternalScreenFilter();
  function switchJournal(jobName:JobNames, jobId:number, branch:string = '', searchModel:JournalLedgerListItem|null = null, toolTipText: string = '') {
    if(jobName === JobNames.None || jobId < 0) {
      return;   // Nothing to do
    }

    if(searchModel === null) {
      searchModel = new JournalLedgerListItem();
    }
    // 250808.inhyung.Issue#2648 Journal 중복 허용(같은 데이터 제외) 및 ToolTipText 전송
    const tbName = getTbNameByJobName(jobName);
    switch(jobName) {
      case JobNames.GInvo:
      case JobNames.Invoice:
        toolTipText = "Customer : " + toolTipText;
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      case JobNames.Bill:
      case JobNames.GBill:
        toolTipText = "Vendor : " + toolTipText;
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      case JobNames.CrDb:
        toolTipText = "Agent : " + toolTipText;
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      case JobNames.OIHbl:
      case JobNames.OEHbl:
      case JobNames.AIHbl:
      case JobNames.AEHbl:
        toolTipText = "HBL # : " + toolTipText;
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      case JobNames.CustPayment:
      case JobNames.BillPayment:
      case JobNames.CCPayment:
      case JobNames.AgntPayment:
        toolTipText = "Check # : " + toolTipText;
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      case JobNames.AllPayment: //View Payment History에서 사용
        toolTipText = "Billings # : " + toolTipText;
        searchModel.tbId = 0; //tbId가 여러개일 수 있어 SearchField에 포함 안 시키기 위함
        searchModel.tbName = tbName;
        break;
      case JobNames.PayrollSummary:
      case JobNames.Payroll2:
      case JobNames.WHStorageInv:
      case JobNames.WHInvoice:
      case JobNames.WHBill:
      case JobNames.WHCrDb:
      case JobNames.SalesTaxReturn:
      case JobNames.BankTransfer:
      case JobNames.Distribution:
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      case JobNames.OIMbl:
      case JobNames.OEMbl:
      case JobNames.AIMbl:
      case JobNames.AEMbl:
      case JobNames.OtherOP:
        toolTipText = "Ref # : " + toolTipText;
        searchModel.mtbName = tbName.length > 10 ? tbName.substring(0, 10) : tbName;
        searchModel.mblId = jobId;
        break;
      case JobNames.WHRcv:
      case JobNames.WHShip:
        searchModel.mtbName = tbName.length > 10 ? tbName.substring(0, 10) : tbName;
        searchModel.mblId = jobId;
        break;

      case JobNames.PrepaidExpenseAdjustment:
        searchModel.tbIndex = '11';
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      
      case JobNames.DepreciationAdjustment:
        searchModel.tbIndex = "12";
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      case JobNames.AmortizationAdjustment:
        searchModel.tbIndex = "13";
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      case JobNames.BadDebtExpense:
        searchModel.tbIndex = "16";
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      case JobNames.IncomeTaxAdjustment:
        searchModel.tbIndex = "17";
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      case JobNames.SlipJournal:
          break;
      case JobNames.AdvanceSales:
        searchModel.tbIndex = "19";
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      default:
          jobName = JobNames.None;
          break;
    }

    if(searchModel.tbId && searchModel.tbId > 0) searchModel.searchField.push('TBId');
    if(searchModel.tbName) searchModel.searchField.push('TBName');
    if(searchModel.mblId && searchModel.mblId > 0) searchModel.searchField.push('MBLId');
    if(searchModel.mtbName) searchModel.searchField.push('MTBName');
    if(searchModel.tbIndex) searchModel.searchField.push('TBIndex');
    if(searchModel.paymentIds) searchModel.searchField.push('PaymentIds'); //View Payment History에서 전체 Payment Journal을 조회할 때 사용
    if(branch) {
      searchModel.branch = branch;
      searchModel.searchField.push('Branch');
    }

    const path = `/common/joblistview/acJournal/billings?key=${jobId}`;
    const pathWithTooltip = toolTipText ? `${path}&tt=${encodeURIComponent(toolTipText).replace(/'/g, '%27')}` : path;
    setFilterForScreenExternally(pathWithTooltip, '', '', '', '', false, false, searchModel);
    // pass only searchModel
    openNewPage(history, pathWithTooltip, NavigationType.newPage);
  }

  return { switchJournal };
}

function AfterMemoLogButtonCommands() {
  // const jobListContext = useContext(JobListViewContext);
  // const selectedElement = jobListContext.selectedElement as JournalLedgerListItem;
  // const appContext = useContext(ApplicationContext);
  // const listSec = findSecurityTask(appContext, FmsSecTask.AcctSlipJournalList);
  // const [showGlobalOkDialog] = useGlobalOkDialog();
  // const history = useHistory();

  // const operation = 'accounting';

  // const hasSelectedRow = !!selectedElement;
  // const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd && selectedElement.type === "T";

  // function hasOpenedNew() {
  //   return jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acJournal/add`);
  // }

  // async function copy() {
  //   if (!selectedElement) {
  //     return;
  //   }

  //   if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acJournal/add`)) {
  //     await showGlobalOkDialog(<p>New operation is already in progress.</p>);
  //     return;
  //   }

  //   const fkey = selectedElement.fKey;
  //   const seq = selectedElement.seq;
  //   const type = selectedElement.type;
  //   const tbType = selectedElement.tbType;

  //   openNewPage(history, `/${operation}/acJournal/add/${fkey}/${seq}/${type}/${tbType}`, NavigationType.newPage);
  // }

  // return (
  //   <>
     
  //   </>
  // )
  return null;
}

class JournalListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number, opType: string|undefined): Promise<DataFetchResult> {
    const listFilterType = ListFilterType.All;
    const apiResult = await api.getListItems(JobNames.SlipJournal,
      'JournalLedgerListItem',
      JournalLedgerListItem.calculateSearchParameters(search, JournalLedgerListItem.MapSearchFields),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
      undefined, 
      listFilterType);

    if(!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return { data: [], totalCount: 0};
    }

    return { data: JournalLedgerListItem.formatData(apiResult.entities, opType === 'billings' ? 'billings' : ''), totalCount: apiResult.totalCount };
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number, opType: string|undefined): Promise<Array<any>> {
    const listFilterType = ListFilterType.All;
    const apiResult = await api.getListItems(JobNames.SlipJournal, 'JournalLedgerListItem',
      JournalLedgerListItem.calculateSearchParameters(search,JournalLedgerListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
      undefined, 
      listFilterType
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  JournalLedgerListItem.formatData(apiResult.entities, opType === 'billings' ? 'billings' : '');
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(_: string | undefined, systemSettings: SystemSettings | undefined): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    return JournalLedgerListItem.getExportCollection(useBranch).map(x => {
      const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'exRate')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={4} />;
        else if (x.dataIndex === 'seq')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else {
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
          if (x.dataIndex === 'debit')
            colRenderer.Header = () => <span>Debit ({systemSettings?.primaryCurrency})</span>;
          else if (x.dataIndex === 'credit')
            colRenderer.Header = () => <span>Credit ({systemSettings?.primaryCurrency})</span>;
        }
      }

      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'exRate', changedValue: (value: any) => { return Decimalformat(value['exRate'], 4) } });
    colRenderer.push({ accessor: 'seq', changedValue: (value: any) => { return Decimalformat(value['seq'], 0) } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'postDate',
      orderByAscending: false,
    };
  }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings =  accountingJournalList;
    const useBranch = systemSettings?.enableBranch ?? false;
    const cur = systemSettings?.primaryCurrency ?? 'USD';

    const cols = JournalLedgerListItem.getExportCollection(useBranch);
    tsettings.columns = cols.map<TableColumn>(x => {
      const result = { ...x, accessor: x.dataIndex, Header:  x.text.replace('$$currency', cur), filterType: undefined, filterTypeV2: x.type};

      return result;
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderAfterConfigureButton() {
    return (
      <></>
    );
  }

  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: JournalLedgerListItem) {
    const fkey = row.fKey;
    const seq = row.seq;
    const type = row.type;
    const tbType = row.tbType;
    const sideMenu = row.sideMenu;
    const viewUrl = (sideMenu === 'billings' ? `/accounting/acJournal/view/${fkey}/${seq}/${type}/${tbType}/billings` : `/accounting/acJournal/view/${fkey}/${seq}/${type}/${tbType}`);

    return row && row.id ? viewUrl : '';
  }

  getListViewTitle(opType: string | undefined) {
    if(opType === 'billings') return 'Journal';
    else return 'Journal List';
  };

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
  
  commandsAfterFilterBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }

  hasMemo(): boolean {
    return false;
  }
}

export default JournalListView;
